import mapValues from 'lodash/mapValues';

import { LoadedWorkflowV6 } from '../migrateTo6';

type LabwarePropertiesV6 =
  LoadedWorkflowV6['visualWorkflow']['labwareProperties'][string];

// slot would nomally be omitted and re-added as new type,
// but seems to have been missed in a previous migration
export type LabwarePropertiesV7 = LabwarePropertiesV6 & {
  slot?: string;
};

export type VisualWorkflowV7 = Omit<
  LoadedWorkflowV6['visualWorkflow'],
  'labwareProperties'
> & {
  labwareProperties: Record<string, LabwarePropertiesV7>;
};

export type LoadedWorkflowV7 = Omit<LoadedWorkflowV6, 'visualWorkflow'> & {
  visualWorkflow: VisualWorkflowV7;
};

// note: this is papering over labware properties 'slot' being missed in a prev migration
const getSlot = (labware: LabwarePropertiesV6): string | undefined => {
  if ('slot' in labware && typeof labware.slot === 'number') {
    return labware.slot.toString();
  }
  return undefined;
};

export const _migrateTo7 = (
  loadedWorkflow: LoadedWorkflowV6
): LoadedWorkflowV7 => {
  const labwareProperties: VisualWorkflowV7['labwareProperties'] = mapValues(
    loadedWorkflow.visualWorkflow.labwareProperties,
    (labware) => ({
      ...labware,
      slot: getSlot(labware),
    })
  );

  return {
    ...loadedWorkflow,
    visualWorkflow: {
      ...loadedWorkflow.visualWorkflow,
      labwareProperties,
    },
  };
};
